import React from 'react';
import Typography from '@material-ui/core/Typography';


const FooterInformation = () => {

	return (
		<ol>
			<li>
				<Typography variant='caption'>The Centers for Disease Control and Prevention considers an individual fully vaccinated if they are:
					<ul>
						<li>2 weeks after their second dose in a 2-dose series, such as the Pfizer or Moderna vaccines, or</li>
						<li>2 weeks after a single-dose vaccine, such as Johnson &amp; Johnson&apos;s Janssen vaccine.</li>
					</ul>
					&nbsp;&nbsp;If you don&apos;t meet these requirements, regardless of your age, you are <b>not</b> fully vaccinated.
				</Typography>
			</li>
			<li>
				<Typography variant='caption'>
					Either I have received my first dose of Moderna or Pfizer, and my second appointment is scheduled, or I received my final dose less than two weeks ago.
				</Typography>

			</li>
			<li>
				<Typography variant='caption'>
					If you are not vaccinated or if you have not been vaccinated due to medical or religious reasons and you are approved or seeking approval through your individual company&apos;s HR process, please check either &quot;I have not been vaccinated&quot; or &quot;I decline to respond.&quot;
				</Typography>
			</li>
		</ol>
	);
};

export default FooterInformation;